<script>
import { Bar } from 'vue-chartjs'

export default {
    extends: Bar,
    props: {
        title: {
            type: String,
            default: 'Title'
        },
        datasets: {
            type: Array,
            default: () => [40, 20]
        },
        labels: {
            type: Array,
            default: () => ['January', 'February']
        }
    },
    data() {
        return {
            chartdata: {},
            options: {}
        }
    },
    watch: {
        datasets() {
            this.fetch()
        }
    },
    methods: {
        fetch() {
            this.chartdata = {
                labels: this.labels,
                datasets: [
                    {
                        label: this.title,
                        data: this.datasets,
                        backgroundColor: ['#F06595', '#22B8CF', '#FCC419', '#51CF66', '#22B8CF', '#FCC419', '#CED4DA'],
                        borderColor: ['#F06595', '#22B8CF', '#FCC419', '#51CF66', '#22B8CF', '#FCC419', '#CED4DA'],
                        fontColor: '#fff',
                        borderWidth: 3
                    }
                ]
            }

            this.options = {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    labels: {
                        fontSize: 14,
                        fontColor: '#ffffff'
                    }
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                                fontSize: 14,
                                fontColor: '#fff'
                            }
                        }
                    ],
                    xAxes: [
                        {
                            ticks: {
                                fontSize: 14,
                                fontColor: '#fff'
                            }
                        }
                    ]
                }
            }

            this.renderChart(this.chartdata, this.options)
        }
    },
    computed: {
        getLabels() {
            return this.labels
        },
        getDatasets() {
            return this.datasets
        }
    },
    mounted() {
        this.fetch()
    }
}
</script>



// WEBPACK FOOTER //
// src/ui/chart/BarChart.vue